<template>
  <button
    type="button"
    class="group inline-flex items-center gap-1 text-xs uppercase tracking-wide text-muted-foreground hover:text-foreground"
    @click="$emit('sort', field)"
  >
    <span>{{ label }}</span>
    <span class="flex flex-col -space-y-1" aria-hidden="true">
      <ChevronUp class="w-3 h-3" :class="isAsc ? 'text-foreground' : 'text-muted-foreground/40'" />
      <ChevronDown class="w-3 h-3" :class="isDesc ? 'text-foreground' : 'text-muted-foreground/40'" />
    </span>
  </button>
</template>

<script>
import { ChevronUp, ChevronDown } from 'lucide-vue-next'

/**
 * A sortable table header.
 *
 * <p>Sorting is server-side (tables are paged), so this only reports which field was clicked and
 * reflects the current direction — the parent owns the state and refetches.
 */
export default {
  name: 'SortHeader',
  components: { ChevronUp, ChevronDown },
  props: {
    label: { type: String, required: true },
    field: { type: String, required: true },
    sortBy: { type: String, default: '' },
    sortDir: { type: String, default: 'asc' },
  },
  emits: ['sort'],
  computed: {
    isActive() {
      return this.sortBy === this.field
    },
    isAsc() {
      return this.isActive && this.sortDir !== 'desc'
    },
    isDesc() {
      return this.isActive && this.sortDir === 'desc'
    },
  },
}
</script>
